// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-yNuIxw","logo":"logo-jxPgAr","title":"title-FOzfKR"};